import { useDispatch } from 'react-redux';
import { FormControl, MenuItem, Select } from '@mui/material';
import {
  setShowHideFuncNum,
  setShowHideOperatorValue,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { equalPatternCollections } from './ShowHide';

interface Props {
  propKey: string;
  h: string;
  setH: React.Dispatch<React.SetStateAction<string>>;
  selectedValue: string;
  setSelectedValue: React.Dispatch<React.SetStateAction<string>>;
  value: string | number;
  setValue: React.Dispatch<React.SetStateAction<string | number>>;
  handlefun: (prop: string, fromUseEffect?: boolean) => void;
  setFuncnum: React.Dispatch<React.SetStateAction<string>>;
  iconColor?: string;
  backgroundColor?: string;
}

const Numb = ({
  propKey,
  h,
  setH,
  selectedValue,
  setSelectedValue,
  value,
  setValue,
  handlefun,
  setFuncnum,
  iconColor,
  backgroundColor,
}: Props) => {
  const dispatch = useDispatch();

  setFuncnum('Numb');
  dispatch(setShowHideFuncNum(propKey, 'Numb'));

  const SelectedColumnValue = (event: any) => {
    setSelectedValue(event.target.value);
    dispatch(setShowHideOperatorValue(propKey, event.target.value));
  };

  const hand = (prop: string) => {
    setH(prop);
  };

  return (
    <div>
      <FormControl fullWidth sx={{ margin: '5px 5px 5px 5px' }}>
        <Select
          sx={{
            width: '95.5%',
            height: '26px',
            fontSize: '13px',
            '&.MuiOutlinedInput-root': {
              '& fieldset': {
                border: '1px solid rgb(211, 211, 211)',
              },
              '&:hover fieldset': {
                border: '1px solid #2bb9bb',
              },
              '&.Mui-focused fieldset': {
                border: '1px solid #2bb9bb',
              },
              '&.Mui-focused svg': {
                color: '#2bb9bb',
              },
              '& svg': {
                color: iconColor ? iconColor : '#404040',
              },
            },
            color: iconColor ? iconColor : '#404040',
          }}
          onChange={SelectedColumnValue}
          value={selectedValue || ''}
          MenuProps={{
            PaperProps: {
              sx: {
                '& .MuiMenuItem-root.Mui-selected': {
                  backgroundColor: 'rgba(43, 185, 187, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(43, 185, 187, 0.2)',
                  },
                },
              },
            },
          }}
        >
          {equalPatternCollections.map((data, index) => (
            <MenuItem
              key={index}
              value={data.value || ''}
              onClick={() => {
                hand(data.value);
                // handlefunc(data.value);
              }}
              sx={{
                color: 'black',
                fontSize: '12px',
                '&:hover': { backgroundColor: 'rgb(238, 238, 238)' },
              }}
            >
              {data.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <input
        type="number"
        className="showHideNumberInput"
        value={value}
        placeholder="Value"
        onChange={(event) => setValue(event.target.value)} // Use onChange to capture the input in real-time
        onBlur={() => handlefun(h)}
        style={{
          backgroundColor: backgroundColor || 'white',
          color: iconColor || '#404040',
        }}
      />
    </div>
  );
};

export default Numb;
